// 26.1.9 Reflect.has(target, propertyKey)
var $export = require('./_export');

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});



//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/core-js/modules/es6.reflect.has.js
// module id = ../../../../core-js/modules/es6.reflect.has.js
// module chunks = 1